export const ROOT = '/users';
export const MODULE = 'USERS';
